// Configuración de usuarios locales para autenticación
import { supabase } from './supabase';

export const AUTH_USERS = {
  judges: [],
  admin: [
    // SEGURIDAD: Credenciales movidas a Supabase Auth
    // Ya no se guardan contraseñas en el código fuente
  ]
};

export const AUTH_ROLES = {
  ADMIN: 'admin',
  JUDGE: 'judge',
  PUBLIC: 'public'
};

export const authenticate = (username, password) => {
  // Buscar en jueces
  const judge = AUTH_USERS.judges.find(u => u.username === username && u.password === password);
  if (judge) {
    return { success: true, role: AUTH_ROLES.JUDGE, user: judge };
  }

  // Buscar en administradores
  const admin = AUTH_USERS.admin.find(u => u.username === username && u.password === password);
  if (admin) {
    return { success: true, role: AUTH_ROLES.ADMIN, user: admin };
  }

  return { success: false, error: 'Usuario o contraseña incorrectos' };
};

// Autenticar juez desde la base de datos (email + password)
export const authenticateJudge = async (email, password) => {
  try {
    // Buscar el juez por email en Supabase
    const { data: judges, error: queryError } = await supabase
      .from('judges')
      .select('*')
      .eq('email', email.toLowerCase())
      .single();

    if (queryError || !judges) {
      return { success: false, error: 'Correo o contraseña incorrectos' };
    }

    // Comparar contraseña (nota: en producción, debería ser bcrypt hash)
    // Por ahora, comparamos directamente (debería mejorarse)
    if (judges.password_hash === password) {
      return {
        success: true,
        role: AUTH_ROLES.JUDGE,
        user: {
          id: judges.id,
          email: judges.email,
          name: judges.name,
          phone: judges.phone,
          address: judges.address
        }
      };
    }

    return { success: false, error: 'Correo o contraseña incorrectos' };
  } catch (error) {
    console.error('Error autenticando juez:', error);
    return { success: false, error: 'Error durante la autenticación' };
  }
};
